import React from 'react'
import TableFooter from '@material-ui/core/TableFooter'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'

const defaultFooterStyles = {}

class CustomFooter extends React.Component {
  render() {
    const { count, disabled, changePage, changeRowsPerPage, pageNumber, totalPages, i18n, type } = this.props
    const isArabic = i18n.language === 'ar'
    const textAlign = isArabic ? 'right' : 'left'
    const flexDirection = isArabic ? 'row-reverse' : 'row'
    const marginDirection = isArabic ? 'ml-4' : 'mr-4'

    return (
      <TableFooter>
        <TableRow>
          <TableCell style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div className="d-flex" style={{ flexDirection }}>
              <div className={`d-flex ${marginDirection}`}>
                <div style={{ textAlign }}>{this.props.t('Rows per page')} :</div>
                <select
                  className="ml-2"
                  value={count}
                  onChange={(e) => changeRowsPerPage(e.target.value)}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  {type == 'coupon' && <option value="500">500</option>}
                </select>
              </div>
              <div>
                <button
                  style={{ border: '1px solid rgba(209,209,209)', color: 'black', padding: 5, borderRadius: 5 }}
                  onClick={() => changePage(pageNumber - 1)}
                  disabled={pageNumber < 1}
                >
                  {this.props.t('Previous')}
                </button>
                <button style={{ margin: '0px 6px', background: 'transparent', border: 'none' }}>
                  {pageNumber + 1} {totalPages ? ' / ' + totalPages : ''}
                </button>
                <button
                  style={{ border: '1px solid rgba(209,209,209)', color: 'black', padding: 5, borderRadius: 5 }}
                  onClick={() => changePage(pageNumber + 1)}
                  disabled={disabled}
                >
                  {this.props.t('Next')}
                </button>
              </div>
            </div>
          </TableCell>
        </TableRow>
      </TableFooter>
    )
  }
}

export default withStyles(defaultFooterStyles, { name: 'CustomFooter' })(withTranslation()(CustomFooter))
